import * as React from 'react'

import { openmbApi } from 'redux/services/open_mb'
import { GetOpenMBParams } from 'redux/services/open_mb/types'

import { AppLayoutTable } from 'components/AppLayoutTable'
import { AppLoader } from 'components/AppLoader'
import { AppPagination } from 'components/AppPagination'
import { AppTable } from 'components/AppTable'

import { OPEN_MB_STATUS_TEXT } from 'constants/open_mb'
import { OpenMB } from 'models/open_mb'

import { formatDate } from 'shared/libs'
import { EmptyDetails } from 'shared/ui'

import { Details } from './components/Details'
import { Filters } from './components/Filters'
import { Statistics } from './components/Statistics'

export const OpenMBPage = () => {
  const [selectedRowId, setSelectedRowId] = React.useState<
    OpenMB['id'] | undefined
  >()
  const [filters, setFilters] = React.useState<GetOpenMBParams>({
    limit: 10,
    offset: 0,
  })
  const [fetch, fetchState] = openmbApi.useLazyGetOpenMBQuery()

  React.useEffect(() => {
    fetch(filters)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters])

  const onChangeFilters = (newFilters: GetOpenMBParams) => {
    newFilters.limit = filters.limit
    newFilters.offset = filters.offset
    setFilters(newFilters)
  }

  return (
    <>
      <AppLayoutTable
        title="МБизнес"
        header={<Filters onSubmit={onChangeFilters} />}
        statistics={<Statistics filters={filters} />}
        sidebarOpened={Boolean(selectedRowId)}
        sidebar={
          selectedRowId ? (
            <Details
              id={selectedRowId}
              onClose={() => setSelectedRowId(undefined)}
            />
          ) : (
            <EmptyDetails />
          )
        }
      >
        {fetchState.isLoading && <AppLoader />}
        {fetchState.data && fetchState.isSuccess && (
          <>
            <AppTable
              onClickRow={item => setSelectedRowId(item.id)}
              dataSource={fetchState.data.results}
              selected={{
                value: selectedRowId,
                key: 'id',
              }}
              headers={[
                {
                  data: 'ID',
                  key: 'id',
                  width: 100,
                },
                {
                  data: 'Название',
                  key: 'name',
                  width: 50,
                },
                {
                  data: 'Дата создания',
                  key: 'created_at',
                  width: 50,
                  render: (_, item) => formatDate(item.created_at),
                },
                {
                  data: 'JIRA',
                  key: 'jira_key',
                  width: 50,
                },
                {
                  data: 'Статус',
                  key: 'status',
                  width: 50,
                  render: (_, item) => OPEN_MB_STATUS_TEXT[item.status],
                },
              ]}
            />

            <AppPagination
              forcePage={filters.offset! / filters.limit!}
              onPageChange={nextPage => {
                setFilters({
                  ...filters,
                  offset: (nextPage - 1) * filters.limit!,
                })
              }}
              count={fetchState.data.count / filters.limit!}
            />
          </>
        )}
      </AppLayoutTable>
    </>
  )
}
